<template>
  <!-- 20200526請判斷上方是否有使用元件，如果有請加class has-widget -->
  <div :class="{ 'has-widget': isWidget }" id="sc-message-list" class="sc-message-list" ref="scrollList">
    <!-- :style="{backgroundColor: colors.messageList.bg}" -->
    <weather v-on:isWeather="isWeather" :Onboarding_action="Onboarding_action" :projectId="projectId"
      v-if="this.$route.params.projectId === 'udn'" v-show="isWidget && !show_noconnection" />
    <!-- 當weather元件isWeather改變狀態就觸發下方isWeather函式-->

    <Message v-for="(message, idx) in messages" :message="message" :chatImageUrl="chatImageUrl(message.author)"
      :authorName="authorName(message.author)" :key="idx" :messageStyling="messageStyling" :projectId="projectId"
      :isMobile="isMobile" :isApp="isApp" :device="device" :returnJSONtoMobile="returnJSONtoMobile"
      @tag-clicked="tagClicked" />
    <Message v-show="authorData == authorData_me" :message="{ author: authorData_bot_human, type: 'typing' }"
      :chatImageUrl="chatImageUrl(authorData_bot_human)" :messageStyling="messageStyling" :projectId="projectId"
      :isMobile="isMobile" :isApp="isApp" :device="device" :returnJSONtoMobile="returnJSONtoMobile" />

  </div>
</template>
<script>
import Message from './Message.vue'
import Weather from './Weather/Weather'
import chatIcon from './assets/chat-icon.svg'

export default {
  components: {
    Message,
    Weather
  },
  data() {
    return {
      showToBottomHeight: 700,
      showToBottom: false,
      scrollTopTimer: "",
      scrolling: false,
      testMessages: {
        type: Array,
        required: true
      },
      testFlag: {
        type: Boolean,
        required: true
      },
      authorData: {
        type: String,
        default: ''
      },
      authorData_me: {
        type: String,
        default: ''
      },
      authorData_bot_human: {
        type: String,
        default: ''
      },
      isWidget: false,
    }
  },
  props: {
    participants: {
      type: Array,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    showTypingIndicator: {
      type: String,
      required: true
    },
    show_noconnection: {
      type: Boolean,
      default: () => false
    },
    Onboarding_action: {
      type: Boolean,
      required: false
    },
    // colors: {
    //   type: Object,
    //   required: true
    // },
    alwaysScrollToBottom: {
      type: Boolean,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: String,
      default: () => ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isApp: {
      type: Boolean,
      default: false
    },
    returnJSONtoMobile: {
      type: Function,
      required: true
    },
    device: {
      type: String,
      default: ''
    }
  },
  methods: {
    tagClicked(value) {
      this.$emit('tag-clicked', value)
    },
    _scrollDown() {
      // try {
      var messages_end_author = JSON.parse(JSON.stringify(this.messages))
      for (let i = messages_end_author.length - 1; i > -1; i--) {
        // console.log('messages_end_author[i].author : ' + messages_end_author[i].author)
        if (messages_end_author[i].author != 'me') {
          // console.log('messages_end_author[i].author : ' + messages_end_author[i].author)
          this.authorData_bot_human = messages_end_author[i].author
          break
        } else if (messages_end_author.length == 1) {


          this.authorData_bot_human = "bot"
          break
        }
      }
      // $('.sc-message-list').animate({
      //       scrollTop: $('.sc-message-list')[0].scrollHeight
      //     }, 'slow')
      if (messages_end_author.length > 0) {
        this.authorData_me = '"me"'
        this.authorData = JSON.stringify(messages_end_author[messages_end_author.length - 1].author)
        // if (this.authorData == '"me"' || sessionStorage.getItem("scrollDown") == 'true') {
        //   this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight
        //   if (sessionStorage.getItem("scrollDown") == 'true') {
        //     sessionStorage.setItem("scrollDown", false)
        //     setTimeout(this.setTimeout_scrollDown, 300)
        //   }
        //   sessionStorage.setItem("scrollDown", false)
        // } else {
        // setTimeout(this.setTimeout_scrollDown, 600);
        // 客服和機器人部分接收資料後執行
        // $('.sc-message-list').animate({
        //   scrollTop: $('.sc-message-list')[0].scrollHeight
        // }, 'slow')
        // }
        this.$emit('show-to-bottom-callback', false)
        // setTimeout(() => {
        //   this.showToBottom = false
          
        // }, 500);
        $('.sc-message-list').animate({
          scrollTop: $('.sc-message-list')[0].scrollHeight
        }, 'normal')
      }
      // --------------------------

    },
    setTimeout_scrollDown() {
      this.$refs.scrollList.scrollTop = this.$refs.scrollList.scrollHeight
    },
    shouldScrollToBottom() {
      return (this.$refs.scrollList.scrollTop < this.$refs.scrollList.scrollHeight - 600)
    },
    profile(author) {
      const profile = this.participants.find(profile => profile.id === author)
      return profile || { imageUrl: '', name: '' }
    },
    chatImageUrl(author) {
      return this.profile(author).imageUrl
    },
    authorName(author) {
      return this.profile(author).name
    },
    isWeather(Value) {
      this.isWidget = Value
    }
  },
  computed: {
    context() {
      try {
        this.testMessages = JSON.parse(JSON.stringify(this.messages))
        for (let i = 0; i < this.testMessages.length; i++) {
          if (this.testFlag && i == 1) {
            this.testFlag = false
            let temp = '{"id":43076,"type":"rich","author":"bot","data":{"text":"歡迎"},"msgJson":"{\\\"msgType\\\":\\\"multiple\\\",\\\"msgList\\\":[{\\\"msgType\\\": \\\"quickReplay\\\",\\\"quickReplies\\\": {\\\"title\\\": \\\"1\\\",\\\"replies\\\": [{\\\"title\\\": \\\"選單\\\"}]}},{\\\"msgType\\\": \\\"quickReplay\\\",\\\"quickReplies\\\": {\\\"title\\\": \\\"2\\\",\\\"replies\\\": [{\\\"title\\\": \\\"選單\\\"}]}}]}","requestTime":1577070672}'
            this.testMessages.splice(this.testMessages.length, 0, JSON.parse(temp))
          }
          if (this.testMessages[i].msgJson != null && this.testMessages[i].msgJson != undefined) {
            if ((JSON.stringify(JSON.parse(this.testMessages[i].msgJson).msgType)) == '\"multiple\"') {
              let temp = this.testMessages[i]
              for (let j = 0; j < JSON.parse(temp.msgJson).msgList.length; j++) {
   
                var y = new String(JSON.stringify(JSON.parse(temp.msgJson).msgList[j]).replace(new RegExp('(["\"])', 'g'), "\\\""))
                let setMultiple = '{"id":' + temp.id
                  + ',"type":"' + temp.type
                  + '","author":"' + temp.author
                  + '","data":' + JSON.stringify(temp.data)
                  + ',"msgJson":"' + y
                  + '","requestTime":' + temp.requestTime
                  + '}'
                this.testMessages.splice(i, j === 0 ? 1 : 0, JSON.parse(setMultiple))
              }
              i = -1
            }
          }
        }
      } catch (e) {
        console.log(e)
      }
      return this.testMessages
    },
    defaultChatIcon() {
      return chatIcon
    }
  },
  mounted() {
    
    $( "#sc-message-list" ).on( "scroll", () => {
      // console.log($('#sc-message-list').prop('scrollHeight'), $('#sc-message-list').scrollTop() + $('#sc-message-list').prop('offsetHeight'))
      // console.log($('#sc-message-list').prop('offsetHeight'), 'offsetHeight')
      // console.log($('#sc-message-list').scrollTop(), )
      const showToBottom = $('#sc-message-list').prop('scrollHeight') > $('#sc-message-list').scrollTop() + $('#sc-message-list').prop('offsetHeight') + this.showToBottomHeight

      if (this.showToBottom !== showToBottom) {
        if (!this.scrolling) {
          this.$emit('show-to-bottom-callback', showToBottom)
          this.showToBottom = showToBottom

        }
      }
      
    });
    this.authorData_bot_human = ''
    // this._scrollDown()

    // // 只要不是是udn news isWidget為false
    if (this.$route.params.projectId !== 'udn') {
      this.isWidget = false
    }
  },
  updated() {
    if (!this.scrolling) {
      this.scrolling = true
      this.$nextTick(this._scrollDown())
      setTimeout(() => {
        this.scrolling = false
      }, 500)
    }
  }
}
</script>

<style scoped>
@import "./styles/messageList.css";

</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/MessageList.vue